<template>
  <div>
    <Head :title="$t('languages.languages') + ` - ${data.name}`" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-gray-400 hover:text-gray-600" href="/languages">{{ $t('languages.languages') }}</Link>
      <span class="text-gray-400 font-medium">/ </span>
      {{ data.name }}
    </h1>
    <trashed-message v-if="data.deleted_at" class="mb-6" @restore="restore"> {{ $t('languages.trashed_message') }}</trashed-message>
    <div class="grid gap-4 lg:grid-cols-2 grid-cols-1">
      <detail-view :data="detailView" />
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import DetailView from '@/Shared/DetailView'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    DetailView,
    Head,
    Link,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    data: Object,
  },
  data() {
    return {
      detailView: {
        items: [
          {label: this.$t('global.name'), value: this.data.name},
          {label: 'Types', value: this.data.types.join(', ')},
          {label: this.$t('languages.empty_field'), value: (this.data.empty_field) ? this.$t('global.yes') : this.$t('global.no')},
        ],
        updateLink: `/languages/${this.data.id}/edit`,
        header: {
          title: 'Language Information',
          text: 'Personal details and contact information.',
        },
      },
    }
  },
}
</script>
